<template>
  <div 
    v-if="
      PAGE_INDEX <= currentPage + 1 && PAGE_INDEX >= currentPage - 1 ||
      PAGE_INDEX === 2 ||
      PAGE_INDEX === 13"
    :id="'page' + PAGE_INDEX"
    :class="{
      'page-container': true,
      'fade-in': PAGE_INDEX < currentPage && PAGE_INDEX !== PAGE_AMOUNT - 1,
      'page-active': PAGE_INDEX === currentPage,
    }"
  >
    <div class="page-background"
      :style="{
        backgroundColor: bgColor,
      }"
    >
      <slot name="background"></slot>
    </div>
    <div :class="{
      'content': true,
      'fly-out': PAGE_INDEX < currentPage && PAGE_INDEX !== PAGE_AMOUNT - 1,
      }"
    >
      <slot name="content"></slot>
    </div>
    <div v-if="scrollDownArrowFlag && currentPage === PAGE_INDEX" class="scroll-down-arrow-wrapper">
      <ScrollDownArrow></ScrollDownArrow>
    </div>
  </div>
</template>

<script>
import ScrollDownArrow from '../ScrollDownArrow.vue';

export default {
  name: 'NormalPage',
  components: {
    ScrollDownArrow,
  },
  props: {
    PAGE_INDEX: {
      type: Number,
      require: true,
    },
    PAGE_AMOUNT: {
      type: Number,
      require: true,
    },
    currentPage: {
      type: Number,
      require: true,
    },
    scrollDownArrowFlag: {
      type: Boolean,
      default: false,
    },
    bgColor: {
      type: String,
      default: '#000000',
    },
    zIndex: {
      type: Number,
      require: true,
    },
  },
};
</script>

<style lang="scss" scoped>
  .page-container {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100vh;
    display: flex;
    justify-content: center;
    align-items: center;
    background-size: cover;
    opacity: 1;
    transition: opacity 0.8s linear;
    overflow: hidden;
    pointer-events: none;
    .page-background {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
    }
    .content {
      position: relative;
      width: 100%;
      height: 100%;
      padding: 20px;
      transition: 1s cubic-bezier(.89,1.4,.68,.94);
      h1 {
        color: #ffffff;
      }
    }
    .scroll-down-arrow-wrapper {
      position: fixed;
      left: 0;
      bottom: 10%;
      width: 100%;
      text-align: center;
    }
  }
  .page-active {
    pointer-events: auto;
  }
  .fade-in {
    opacity: 0;
  }
  .fly-out {
    transform: translateY(-100vh);
  }
</style>
